import { Flex } from 'antd';
import { PhoneOutlined, PushpinOutlined } from '@ant-design/icons';
import whatsappIcon from '../assets/whatsapp.png';
import instagramIcon from '../assets/instagram.png';
import facebookIcon from '../assets/facebook.png';
import twitterIcon from '../assets/twitter.png';
import { useNavigate } from 'react-router-dom';
import { FooterContainer } from '../styled-components/landing';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { RETRIEVE_RESTAURANT_BY_ID } from '../apollo/query/restaurant.query';

const Footer = (props: any) => {
    const { nIDRestaurant } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { data } = useQuery(RETRIEVE_RESTAURANT_BY_ID, { variables: { nID: nIDRestaurant } });

    const redirectToLegal = () => {
        navigate('/legal', { state: { nIDRestaurant: nIDRestaurant }} );
    }

    return (
        <footer style={{ backgroundColor: '#1F1F1F', paddingInline: 50, paddingTop: 50, paddingBottom: 50, color: 'white' }}>
            <FooterContainer>
                <div>
                    <h3 style={{ fontFamily: 'Suburban', fontSize: '1.5rem', letterSpacing: 0.5, marginBottom: 15, marginTop: 0 }}> { t('footer.about-us') } </h3>
                    <p style={{ fontFamily: 'Roboto-Thin', fontSize: '0.8rem', lineHeight: 1.5, color: 'lightgrey', marginBottom: 10 }}>
                       { t('footer.description') } 
                    </p>
                    <Flex vertical gap={20} style={{ fontFamily: 'Roboto-Thin', color: 'lightgrey', fontSize: '0.8rem', marginTop: 20 }}>
                        <Flex gap={10} style={{ marginBottom: 5, cursor: 'pointer' }} onClick={() => window.location.href = `tel:${data?.data?.sPhone}` }>
                            <PhoneOutlined style={{ marginRight: 10 }} /> { data?.data?.sPhone ?? '-' }
                        </Flex>
                        <Flex gap={15} style={{ fontFamily: 'Roboto-Thin', cursor: 'pointer' }} onClick={() => window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(` + ${data?.data?.sName} + ', ' + ${data?.data?.sAddress} `)}`, '_blank') }>
                            <PushpinOutlined /> { data?.data?.sAddress ?? '-' }
                        </Flex>
                    </Flex>
                </div>
                <div>
                    <h3 style={{ fontFamily: 'Suburban', fontSize: '1.5rem', letterSpacing: 0.5, marginBottom: 15, marginTop: 0 }}> { t('footer.quick-links') }  </h3>
                    <Flex vertical gap={20} style={{ fontFamily: 'Roboto-Thin', color: 'lightgrey', fontSize: '0.8rem' }}>
                        { data?.data?.sPhone && 
                            <Flex
                                gap={10} style={{ fontFamily: 'Roboto-Thin', marginBottom: 5, cursor: 'pointer' }}
                                onClick={() => window.open(`https://web.whatsapp.com/send?phone=${data?.data?.sPhone}`) }    
                            >
                                { t('footer.work-with-us') }
                            </Flex>
                        }
                        <Flex gap={10}  style={{ fontFamily: 'Roboto-Thin', marginBottom: 5, cursor: 'pointer' }} onClick={redirectToLegal}>
                            { t('footer.use-conditions') }
                        </Flex>
                        <Flex gap={10}  style={{ fontFamily: 'Roboto-Thin', marginBottom: 5, cursor: 'pointer' }} onClick={redirectToLegal}>
                            { t('footer.privacy-policy') }
                        </Flex>
                    </Flex>
                </div>
                <div>
                    <h3 style={{ fontFamily: 'Suburban', fontSize: '1.5rem', letterSpacing: 0.5, marginBottom: 15, marginTop: 0 }}> { t('footer.connect-with-us') } </h3>
                    <Flex gap={30}>
                        <a href={`https://wa.me/+34${data?.data?.sPhone.replaceAll(' ', '')}`} target='_blank' rel="noreferrer">
                            <img src={whatsappIcon} height={20} width={20} alt='Whatsapp Icon' />
                        </a>
                        <a href='https://www.instagram.com/ams.restaurant/' target='_blank' rel="noreferrer">
                            <img src={instagramIcon} height={20} width={20} alt='Instagram Icon' />
                        </a>
                        <a href='https://www.facebook.com/AmsRestaurantEmpuriabrava' target="_blank" rel="noreferrer" >
                            <img src={facebookIcon} height={20} width={20} alt='Facebook Icon' />
                        </a>
                        <a href='https://x.com/AmsRestaurant' target='_blank' rel="noreferrer">
                            <img src={twitterIcon} height={20} width={20} alt='Twitter Icon' />
                        </a>
                    </Flex>
                </div>
            </FooterContainer>
        </footer>
    );
}   

export default Footer   